import html from "html-literal";

export default () => html`
  <footer>
    &copy; 2022 <a href="https://je-ff.netlify.app/">Jeff Edson</a>
  </footer>
`;
